/** Prefix spreadsheet formula triggers for safe CSV downloads. */
export function sanitizeCsvCell(value: unknown): string {
  if (value === null || value === undefined) return '';
  const text = String(value);
  if (text && /^[=+\-@\t\r]/.test(text)) {
    return `'${text}`;
  }
  return text;
}

export function csvRow(values: unknown[]): string {
  return values.map(sanitizeCsvCell).join(',');
}
